<a routerLink="/">
  <ideal-horizontal-logo></ideal-horizontal-logo>
</a>
